import React from "react";

export const MainLayout = ({ children }) => {
  return (
    <div className="min-h-screen flex flex-col items-stretch px-4 py-4">
      {children}
    </div>
  );
};
